import { AdminStatusDto, CandidateStatusDto, GenderDto, QuizScoreDto } from '@/api/generated';

import type { AdminViewTranslations } from './adminView.translations.pl.ts';
import { candidatesTranslations } from './candidates.translations.en.ts';
import { dashboardTranslations } from './dashboard.translations.en.ts';
import { fairsTranslations } from './fairs.translations.en.ts';
import { reportsTranslations } from './reports.translations.en.ts';

export const adminViewTranslations: AdminViewTranslations = {
  candidates: candidatesTranslations,
  dashboard: dashboardTranslations,
  details: {
    adminStatus: 'Admin status',
    adminStatuses: {
      [AdminStatusDto.None]: 'None',
      [AdminStatusDto.OnHoldAdmin]: 'On hold (admin)',
      [AdminStatusDto.OnHoldConditional]: 'On hold (conditional)',
    },
    phone: 'Phone',
  },
  preview: {
    sections: {
      additional: 'Additional information',
      basic: 'Basic data',
      dates: 'Dates',
      statusAndResults: 'Status and results',
    },
  },
  filters: {
    actionPossibleFrom: 'Assessment possible from',
    actionPossibleTo: 'Assessment possible until',
    adminStatus: 'Admin status',
    adminStatuses: {
      [AdminStatusDto.OnHoldAdmin]: 'On hold - Admin',
      [AdminStatusDto.OnHoldConditional]: 'On hold - Conditional',
    },
    title: 'Filters',
  },
  pointsLegend: {
    decision: 'Decision',
    doNotSend: "Don't send",
    max: 'Max',
    min: 'Min',
    score: 'Score',
    send: 'Send',
    title: 'Points legend',
  },
  actions: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirmMessages: {
      default: 'Are you sure you want to perform this action?',
      negativeFeedback: 'Are you sure you want to set negative feedback for this candidate?',
      onHold: "Are you sure you want to put this candidate's process on hold?",
      positiveFeedback: 'Are you sure you want to set positive feedback for this candidate?',
    },
    confirmTitle: 'Confirm action',
    genderLabel: "Candidate's gender",
    genderTitle: 'Choose gender',
    labels: {
      gender: 'Set gender',
      negativeFeedback: 'Set negative feedback',
      onHold: 'Put process on hold',
      positiveFeedback: 'Set positive feedback',
    },
    noActions: 'No actions available',
    save: 'Save',
    toggle: 'Actions',
  },
  confirmPositiveFeedbackModal: {
    title: 'Confirm positive feedback',
    body: 'Are you sure you want to confirm positive feedback?',
    closeLabel: 'Cancel',
    confirmLabel: 'Confirm',
  },
  search: {
    email: 'Email',
    phone: 'Phone number',
    statuses: 'Status',
    lastName: 'Last name',
    quizScore: 'Quiz score',
    locationIds: 'Locations',
    adminActionPossibleBeforeFrom: 'Action possible from',
    adminActionPossibleBeforeTo: 'Action possible until',
    isFromFair: 'From job fairs',
    adminStatuses: 'Admin statuses',
  },
  buttons: {
    submit: 'Search',
    clear: 'Clear',
    logout: 'Log out',
  },
  tabs: {
    candidates: 'Candidates',
    dashboard: 'Dashboard',
    fairCandidates: 'Job fairs',
    reports: 'Reports',
  },
  fairs: fairsTranslations,
  reports: reportsTranslations,
  tooltips: {
    downloadCv: 'Download CV',
    downloadFullAudit: 'Download full candidate audit',
    downloadProcessCv: 'Download process file',
    setPositiveFeedback: 'Change the assessment to positive',
    viewCandidate: 'View candidate',
  },
  table: {
    decisionOverridden: 'Decision overridden',
    name: 'Candidate',
    email: 'Email',
    status: 'Status',
    quizScore: 'Quiz score',
    sourceApp: 'Source',
    noOfQuizRevisits: 'No. of visits',
    areasOfInterests: 'Business areas',
    location: 'Location',
    university: 'University',
    gender: 'Gender',
    isFromFair: 'From fairs',
    statuses: {
      [CandidateStatusDto.SentToERecruiter]: 'Sent to eRecruiter',
      [CandidateStatusDto.PositiveFeedback]: 'Positive game result',
      [CandidateStatusDto.NegativeFeedback]: 'Negative game result',
      [CandidateStatusDto.PositiveFeedbackSent]: 'Positive feedback sent',
      [CandidateStatusDto.NegativeFeedbackSent]: 'Negative feedback sent',
      [CandidateStatusDto.InQuiz]: 'Playing the game',
      [CandidateStatusDto.QuizFinished]: 'Game finished',
      [CandidateStatusDto.PersonalDataProvided]: 'Personal data provided',
      [CandidateStatusDto.EmailProvided]: 'Email provided',
      [CandidateStatusDto.CandidateProcessFinished]: 'Process finished',
      [CandidateStatusDto.EmailVerified]: 'Email verified',
      [CandidateStatusDto.QuizExpired]: 'Game time exceeded',
      [CandidateStatusDto.QuizRevisitsExceeded]: 'Game visit limit exceeded',
      [CandidateStatusDto.QuizPointsResultReady]: 'Points result ready',
    },
    quizScores: {
      [QuizScoreDto.Low]: 'Low',
      [QuizScoreDto.Average]: 'Average',
      [QuizScoreDto.Good]: 'Good',
      [QuizScoreDto.VeryGood]: 'Very good',
      [QuizScoreDto.Outstanding]: 'Outstanding',
    },
    genders: {
      [GenderDto.Male]: 'Male',
      [GenderDto.Female]: 'Female',
      [GenderDto.Unknown]: 'Unknown',
    },
    quizPoints: 'Points',
    statusUpdatedAt: 'Status change date',
    quizFinishedAt: 'Quiz finished',
    adminActionPossibleBefore: 'Assessment possible until',
    possibleAdminActionTypes: 'Available actions',
    yes: 'Yes',
    no: 'No',
  },
};
